// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_dmG","cls2":"LoswpTabsHero-cls2_bqd LoswpTabsHero-cls1_dmG"};